(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosalind-biscuit-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(root){
    root.querySelectorAll('.rj-biscuit').forEach(function(story){
      if(story.dataset.initialized)return;
      story.dataset.initialized='true';
      if(story.dataset.animate!=='true'||story.dataset.animation==='none'||window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
      if(story.dataset.mobileOff==='true'&&window.matchMedia('(max-width:760px)').matches)return;
      var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-revealing');observer.unobserve(entry.target);}});},{threshold:.1});
      story.querySelectorAll('.rj-biscuit__figure').forEach(function(figure){observer.observe(figure);});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initialize(document);});}else{initialize(document);}
  document.addEventListener('shopify:section:load',function(event){initialize(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
